import fetchExpresso from 'utility/fetchExpresso';

export type EventDashboardStats = {
    total_orders: number;
    total_revenue: number;
    total_tickets: number;
    pos_total_orders: number;
    pos_total_revenue: number;
    pos_total_tickets: number;
    scan_count: number;
    pos_scan_count: number;
    product_count: number;
    topCities: Array<{
        city: string;
        province: string;
        order_count: number;
        revenue: number;
    }>;
    payout_amt: number | null;
    payout_date: string | null;
    seat_event_key: string | null;
    seats_private_key: string | null;
    connect_type_id: number;
    charges_enabled: number;
    payouts_enabled: number;
    onboarding_complete: number;
    requirements_due: string | null;
};

export async function fetchEventDashboardStats(
    eventId: number,
    timezone: string,
): Promise<EventDashboardStats> {
    const res = await fetchExpresso(
        `/apiv2/events/${eventId}/dashboard?tz=${encodeURIComponent(timezone)}`,
    );

    if (!res.ok) {
        throw new Error('Failed to load event dashboard stats');
    }

    return (await res.json()) as EventDashboardStats;
}
